import React from 'react';
import { Notifications, NotificationsNone } from '@material-ui/icons';
import Badge from '@material-ui/core/Badge';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';



const styles = theme => ({
	badge: {
		margin: `0 ${theme.spacing.unit * 2}px`,
	},
});



class NotificationBell extends React.PureComponent {
	render() {
		const classes = this.props.classes;
		let not = this.props.notifications;

		if ( !not.length ) {
			return <NotificationsNone onClick={this.props.onClick} />;
		}

		return (
			<Badge
				className={classes.badge}
				badgeContent={not.length > 9 ? '9+' : not.length}
				color="secondary"
				onClick={this.props.onClick}
			>
				<Notifications />
			</Badge>
		);
	}
}



NotificationBell.defaultProps = {
	notifications: [],
};


NotificationBell.propTypes = {
	notifications: PropTypes.array.isRequired,
};

export default withStyles( styles )( NotificationBell );
